import React, { useState, useEffect, FC, useCallback } from "react"
import { useIntl } from "react-intl"
import { observer } from "mobx-react-lite"

import Languages from "layouts/RedesignedLayout/navigation/contents/Languages"
import commonMessages from "messages/common"
import Modal, { BodyContainer } from "components/UI/Modal"
import Arrow from "assets/icons/arrow"

import styles from "components/v3/LanguageSettingsModal/index.module.scss"

interface Props {
	isOpen: boolean
	onBack?: () => void
	onClose: () => void
}

const Index: React.FC<Props> = ({ isOpen, onBack, onClose }) => {
	const { formatMessage } = useIntl()

	return (
		<Modal
			label={formatMessage(commonMessages.language_setting)}
			iconClassName="ai ai-web_outlined"
			isOpen={isOpen}
			onClose={onClose}
		>
			<BodyContainer>
				<div className={styles.container}>
					<div className={styles.header}>
						{onBack && (
							<button type="button" className={styles.backBtn} onClick={onBack}>
								<Arrow />
							</button>
						)}
						<span>Select your language</span>
					</div>
					<Languages />
				</div>
			</BodyContainer>
		</Modal>
	)
}

export default observer(Index)
